const promotionResource = {
    name: 'Promotion name',
    guacPercentage:'Guac cashback percentage',
    userPercentage: 'User cashback percentage'
}

export default promotionResource;